"use client";

import { Button } from "@heroui/react";
import { ArrowRight, CalendarCheck2 } from "lucide-react";
import ScrollReveal from "./ScrollReveal";
import { SCHEDULE_DEMO_URL } from "@/lib/site-config";

/** Closing conversion section: one confident action — schedule the demo. */
export default function DemoCtaSection() {
  return (
    <section
      id="demo"
      className="px-6 pt-16 sm:pt-20 pb-20 sm:pb-24 relative overflow-hidden"
    >
      {/* Gradient blobs for glassmorphism refraction */}
      <div
        className="pointer-events-none absolute top-1/2 left-1/3 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[500px]"
        style={{
          background:
            "radial-gradient(ellipse 60% 50% at 50% 50%, rgba(101,129,234,0.09) 0%, transparent 70%)",
        }}
      />
      <div
        className="pointer-events-none absolute top-1/2 right-1/4 translate-x-1/2 -translate-y-1/2 w-[500px] h-[400px]"
        style={{
          background:
            "radial-gradient(ellipse 50% 50% at 50% 50%, rgba(103,180,193,0.05) 0%, transparent 70%)",
        }}
      />

      <div className="relative mx-auto max-w-xl text-center">
        <ScrollReveal>
          <span className="inline-block rounded-full px-3.5 py-1 text-sm sm:text-base font-semibold text-dark-teal/40 mb-0">
            Empieza hoy
          </span>
        </ScrollReveal>

        <ScrollReveal delay={0.1}>
          <h2 className="flex flex-col text-balance font-medium text-[2rem] sm:text-[36px] lg:text-5xl tracking-[-0.02em] text-dark-teal leading-[1.1] sm:leading-none mb-4">
            <span>Deja las planillas.</span>
            <span className="bg-linear-to-r from-[#6581EA] to-[#67B4C1] bg-clip-text text-transparent">
              Empieza a verificar.
            </span>
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={0.15}>
          <p className="text-pretty text-[.95rem] sm:text-[18px] leading-[1.6] text-dark-teal/50 max-w-[480px] mx-auto mb-10">
            Agenda una demo de 30 minutos con tu propio caso: te mostramos cómo
            Verify y Veri ordenan tu cumplimiento desde el día uno.
          </p>
        </ScrollReveal>

        <ScrollReveal delay={0.2}>
          <Button
            onPress={() => {
              window.open(SCHEDULE_DEMO_URL, "_blank", "noopener,noreferrer");
            }}
            className="btn-glow mx-auto flex h-12 items-center gap-3 rounded-2xl bg-accent px-7 text-[15px] font-semibold tracking-[-0.01em] text-white hover:bg-[#5570e0]"
          >
            <CalendarCheck2 className="h-4.5 w-4.5 text-white/85" strokeWidth={2} />
            Agendar una demo
            <ArrowRight className="h-4 w-4 text-white/80" strokeWidth={2} />
          </Button>
        </ScrollReveal>

        <ScrollReveal delay={0.25}>
          <p className="text-[13px] text-dark-teal/30 mt-8">
            30 minutos · Google Meet · sin compromiso
          </p>
        </ScrollReveal>
      </div>
    </section>
  );
}
